import { ErrorsState } from 'components/search/expedia/interfaces';

const initialErrorsState: ErrorsState = {
  errors: {},
};

export { initialErrorsState };
